import { forwardRef, Ref, useState } from "react";
import { FieldValues, Path, UseControllerProps, UseFormSetValue } from "react-hook-form";
import { createEditor } from "slate";
import { withHistory } from "slate-history";
import { Editable, Slate, withReact } from "slate-react";
import { toHtml, toSlateJson } from '../../shared/components/editor/utils/serializers';
import { Box } from "../../shared/components/widgets/Box";
import { Toolbar } from "../../shared/components/editor/Toolbar";
import { RenderElement, RenderLeaf } from "../../shared/components/editor/Renders";
import '../../shared/components/editor/styles/editor-styles.css'
import { Vendor } from "../vendorsSlice";

interface EditorBodyFieldProps<T extends FieldValues>
    extends UseControllerProps<T> {
  name: Path<T>,
  label: string,
  value: string,
  error: string | undefined,
  onBlur: any,
  onChange: any
}

export const VendorEntryEditor = forwardRef(<T extends FieldValues>(props: {
  name: Path<T>,
  label: string,
  value: string,
  setValue: UseFormSetValue<Vendor>,
  error: string | undefined,
  onBlur: any,
  onChange: any
} & EditorBodyFieldProps<T>, ref: Ref<HTMLDivElement>) => {

  const [editor] = useState(() => withHistory(withReact(createEditor())))

  const { isVoid, isInline } = editor;

  editor.isVoid = (el) => el.type === 'image' || isVoid(el)
  editor.isInline = element => ['link'].includes(element.type) || isInline(element)

  const initialValue = (props.value) ? toSlateJson(props.value) : toSlateJson('<p></p>');

  const handleChange = (fieldValue: any) => {
    const isAstChange = editor.operations.some(op => 'set_selection' !== op.type)
    if (isAstChange) {
      const htmlValue = toHtml(fieldValue)
      props.setValue('description', htmlValue);
      props.onChange(htmlValue);
    }
  }

  return (
    <Slate editor={editor} onChange={e => handleChange(e)} initialValue={initialValue}>
      <label htmlFor={props.label} className='form-label'>
        {props.label}
      </label>
      <Box
        position="sticky"
        width="100%"
        bgColor="white"
        zIndex="10"
        btlRad="10px"
        btrRad="10px"
        boxShadow='0 1px 3px rgba(64, 64, 64, 0.5)'
        p='2px'
      >
        <Toolbar />
      </Box>
      <Box
        bgColor='EDF2F6'
        bblRad='10px'
        bbrRad='10px'
        boxShadow='0 1px 3px rgba(64, 64, 64, 0.5)'
        mb='1rem'
      >
        <Editable
          className='editor-input'
          ref={ref}
          renderElement={RenderElement}
          renderLeaf={RenderLeaf}
          autoFocus
          placeholder="Write something..."
        />
      </Box>
    </Slate>
  );
});
